// extracted by mini-css-extract-plugin
export default {"headingH1":"heading_headingH1__NInh1"};